(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["group"] && !Shopify.designMode) return;
  try {
    /**
   * Override Shopify Forms app Shadow DOM max-width constraint.
   * The app sets max-width: 450px on its internal form container,
   * preventing the form from stretching to fill its parent.
   * Since the Shadow DOM is open, we can inject a <style> override.
   */
  (function() {
    function overrideFormsMaxWidth(formsEmbed) {
      const shadowRoot = formsEmbed.shadowRoot;
      if (!shadowRoot || shadowRoot.querySelector('#codefy-forms-override')) return;

      const style = document.createElement('style');
      style.id = 'codefy-forms-override';
      style.textContent = `
        [class*="formContainer"] {
          max-width: none !important;
          width: 100% !important;
        }
      `;
      shadowRoot.appendChild(style);
    }

    // Handle elements already in the DOM
    document.querySelectorAll('shopify-forms-embed').forEach(overrideFormsMaxWidth);

    // Handle elements added dynamically
    const observer = new MutationObserver(function(mutations) {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1) {
            if (node.tagName === 'SHOPIFY-FORMS-EMBED') {
              overrideFormsMaxWidth(node);
            }
            node.querySelectorAll && node.querySelectorAll('shopify-forms-embed').forEach(overrideFormsMaxWidth);
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
